import { render, staticRenderFns } from "./SupplierContactPerson.vue?vue&type=template&id=24bf06e5&"
import script from "./SupplierContactPerson.vue?vue&type=script&lang=js&"
export * from "./SupplierContactPerson.vue?vue&type=script&lang=js&"
import style0 from "./SupplierContactPerson.vue?vue&type=style&index=0&id=24bf06e5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports